import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

/** ダイアログタイプ */
export type DialogType = 'error' | 'warn' | 'warning' | 'info';

/** ダイアログオプション */
export type DialogOption = {
  /** タイプ */
  type: DialogType;

  /** メッセージ */
  message: string;

  /** タイトル */
  title?: string;

  /** 操作 */
  operation?: string;
};

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './alert-dialog.component.html',
  styleUrl: './alert-dialog.component.scss',
})
export class AlertDialogComponent {
  /** タイトル */
  public title = 'Error';

  /** メッセージ */
  public message = '';

  /** 操作 */
  public operation: string | undefined;

  /** ダイアログタイプ */
  private type: DialogType = 'error';

  /** デフォルトタイトル一覧 */
  private readonly defaultTitleList: Record<DialogType, string> = {
    info: 'Information',
    warn: 'Warning',
    warning: 'Warning',
    error: 'Error',
  };

  /** タイトルCSSクラス一覧 */
  private readonly titleClassList: Record<DialogType, string> = {
    info: 'matp-bg-primary',
    warn: 'matp-bg-accent',
    warning: 'tw-bg-yellow-500',
    error: 'matp-bg-warn',
  };

  /** タイトルアイコン一覧 */
  private readonly titleIconList: Record<DialogType, string> = {
    info: 'info',
    warn: 'check_circle',
    warning: 'check_circle',
    error: 'cancel',
  };

  /** ボタン色一覧 */
  private readonly btnColorList: Record<DialogType, string> = {
    info: 'primary',
    warn: 'accent',
    warning: 'accent',
    error: 'warn',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) data: DialogOption,
    private dialogRef: MatDialogRef<AlertDialogComponent>,
  ) {
    this.type = data.type;
    this.title = data.title || this.defaultTitleList[data.type];
    this.message = data.message;
    this.operation = data.operation;
  }

  /**
   * 操作を実行する
   */
  public doOperation() {
    this.dialogRef.close(true);
  }

  /** タイトルCSSクラス */
  public get titleClass(): string {
    return this.titleClassList[this.type];
  }

  /** タイトルアイコン */
  public get titleIcon(): string {
    return this.titleIconList[this.type];
  }

  /** 操作ボタン色 */
  public get operationBtnColor(): string {
    return this.btnColorList[this.type];
  }
}
